import * as sanitizeHtml from 'sanitize-html'
import clsx from "clsx";

const defaultOptions = {
    allowedTags: ['h1', 'h2', 'h3', 'p','b', 'i', 'em', 'strong', 'a', 'li', 'ul', 'ol', 'br'],
    allowedAttributes: {
        'a': [ 'href', 'target' ]
    },
};

// Function to add class to each tag in the sanitized HTML
const addClassesToTags = (html, tagStyles) => {
    if (!tagStyles || Object.keys(tagStyles).length === 0) return html;
    
    let modifiedHtml = html;
    
    Object.entries(tagStyles).forEach(([tag, className]) => {
        const regex = new RegExp(`<${tag}(\\s|>)`, 'g');
        modifiedHtml = modifiedHtml.replace(regex, `<${tag} class="${className}"$1`);
    });
    
    return modifiedHtml;
};

const sanitize = (dirty, options, tagStyles) => {
    // First sanitize the HTML
    const sanitized = sanitizeHtml(
        dirty,
        {...defaultOptions, ...options}
    );
    
    // Then add classes to specific tags if provided
    const withClasses = tagStyles ? addClassesToTags(sanitized, tagStyles) : sanitized;
    
    return { __html: withClasses };
};

export default function SanitizeHTML({
    className, 
    children, 
    options, 
    tagStyles
}: {
    className?: string, 
    children: string, 
    options?: any,
    tagStyles?: Record<string, string>
}) {
    return (
        <div 
            className={clsx('font-bl-pylon text-base text-black-text', className)} 
            dangerouslySetInnerHTML={sanitize(children, options, tagStyles)} 
        />
    );
}